import { asapScheduler, Observable, OperatorFunction } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Severity } from '../enums/severity';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';
import { HttpEventType } from '@angular/common/http';

export function toastyReport<T>(
  actionClass: { success: string; error: string },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: any
): OperatorFunction<T, T> {
  return function handleClassOperatorFunction(
    source: Observable<T>
  ): Observable<T> {
    return source.pipe(
      tap({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: (event: any) => {
          if (event.type === HttpEventType.Response && actionClass.success) {
            asapScheduler.schedule(() => {
              dispatch(
                new NotificationsActions.Toast(
                  actionClass.success,
                  Severity.Success
                )
              );
            });
          }
        },
        error: () => {
          if (actionClass.error) {
            asapScheduler.schedule(() => {
              dispatch(
                new NotificationsActions.Toast(
                  actionClass.error,
                  Severity.Error
                )
              );
            });
          }
        },
      })
    );
  };
}
